import { Check } from '@mui/icons-material'
import { Stack } from '@mui/material'
import type { GridRenderCellParams } from '@mui/x-data-grid-pro'

export const CheckboxCell = (params: GridRenderCellParams) => (
  <Stack height="100%" justifyContent={'center'} alignItems={'center'}>
    {params.value ? <Check /> : null}
  </Stack>
)
